import * as React from 'react';
import {Grid, Typography, Divider, Tooltip} from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

export default function CardData({fieldList}) {
  
  return (
    <Grid item sx={{width:'100%', backgroundColor:'white',  alignItems:"center"}} >
        <Grid container  justifyContent="space-between" direction="row"   sx={{width:'100%'}}>
          {
            fieldList.map((field, i)=>{
              return (
                <Grid item key={i} xs={6} sm={4} md={4} lg={4} > 
                  <Typography   variant="h6" >{field.fieldLabel}</Typography>
                  <Typography color="textSecondary" sx={{ fontWeight: 'light',fontSize: 12 }}>{field.fieldValue}</Typography>
              </Grid>
              )
            })
          }
         
        </Grid>
      <Divider/>
    </Grid>
       
  );
}